/**
 *
 * @param state
 * @returns {(function({isExpanded: boolean, optionSelected: string}=, *): (*&{isExpanded: boolean, optionSelected: string}))|*}
 */
export const sidePanelSelector = state => state.ui.sidePanel;
